import { render, staticRenderFns } from "./moveToCreate.vue?vue&type=template&id=dc652f26&scoped=true&"
import script from "./moveToCreate.vue?vue&type=script&lang=js&"
export * from "./moveToCreate.vue?vue&type=script&lang=js&"
import style0 from "./moveToCreate.vue?vue&type=style&index=0&id=dc652f26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc652f26",
  null
  
)

export default component.exports